import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { GetClientsVm } from './get-clients.vm';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getClients = async (offset: string, term: string, callback: CallbackObject<GetClientsVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  if (term) {
    config.params.term = term;
  }

  try {
    const res: AxiosResponse = await instance.get(`/picking/clients`, config);
    callback.success(plainToClass(GetClientsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
